import { Badge } from "@/components/ui/badge";
import { BathIcon, BedIcon } from "lucide-react";
import { useTranslations } from "next-intl";
type RealEstateDetailLeftBadgesProps = {
  realEstateNumRooms?: number;
  realEstateBathrooms?: number;
  numPersonsAllowed?: number;
};
export function RealEstateDetailLeftBadges({
  realEstateNumRooms,
  realEstateBathrooms,
  numPersonsAllowed
}: RealEstateDetailLeftBadgesProps) {
  const t = useTranslations("modules.realEstateDetail");
  return <div className="flex gap-2 items-center" data-sentry-component="RealEstateDetailLeftBadges" data-sentry-source-file="RealEstateDetailLeftBadges.tsx">
      {numPersonsAllowed > 0 && <Badge size="md" variant="muted" className="bg-card rounded-full cursor-default">
          <span className="capitalize">
            {numPersonsAllowed === 1 ? t("singleRoom") : numPersonsAllowed === 2 ? t("doubleRoom") : t("dormitory")}
          </span>
        </Badge>}
      {realEstateNumRooms > 0 && <Badge size="md" variant="muted" className="bg-card rounded-full cursor-default">
          <BedIcon className="w-[16px] h-[16px]" />
          <span>{realEstateNumRooms}</span>
        </Badge>}
      {realEstateBathrooms > 0 && <Badge size="md" variant="muted" className="bg-card rounded-full cursor-default">
          <BathIcon className="w-[16px] h-[16px]" />
          <span>{realEstateBathrooms}</span>
        </Badge>}
    </div>;
}